import { TipoCampoFormulario } from 'src/app/compartido/formulario/utilidades/formulario.models';
import {
  ConfiguracionTablaAsincrona,
  FilaTabla,
  TipoColumnaTabla,
} from 'src/app/compartido/tabla/utilidades/tabla.models';
import {
  ESTADOS_ORDEN_ERROR,
  ESTADOS_ORDEN_PREPARADA,
  OPCIONES_ESTADO_REAL_ORDEN,
  OPCIONES_PRIORIDAD_ORDEN,
  OPCIONES_TIPO_ORDEN,
} from '../../../utilidades/ordenes.static';
import {
  Permiso,
  RolUsuario,
} from 'src/app/nucleo/autorizacion/autorizacion.models';
import { VerOrdenComponent } from '../../ver-orden/ver-orden.component';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';
import { EstadoOrden } from 'src/app/ordenes/utilidades/ordenes.models';
import { CancelarOrdenComponent } from 'src/app/ordenes/componentes/cancelar-orden/cancelar-orden.component';
import { CONFIGURACION_FICHA_CANCELAR_ORDEN } from 'src/app/ordenes/componentes/cancelar-orden/utilidades/cancelar-orden.static';
import { CONFIGURACION_FICHA_VER_ORDEN } from '../../ver-orden/utilidades/ver-orden.static';

/* Configuración de la tabla de órdenes */
export const CONFIGURACION_TABLA_ORDENES: ConfiguracionTablaAsincrona = {
  columnas: [
    { slug: 'id', nombre: 'ID' },
    { slug: 'titulo', nombre: 'Título' },
    { slug: 'estado_real_display', nombre: 'Estado' },
    { slug: 'tipo_display', nombre: 'Tipo' },
    { slug: 'prioridad_display', nombre: 'Prioridad' },
    { slug: 'domicilio', nombre: 'Domicilio ID' },
    { slug: 'referencia', nombre: 'N° Referencia' },
    { slug: 'origen', nombre: 'Punto de Origen' },
    {
      slug: 'fecha_creacion',
      nombre: 'Fecha Creación',
      tipo: TipoColumnaTabla.FECHA,
      ordenable: true,
    },
    {
      slug: 'fecha_preparacion',
      nombre: 'Fecha Preparación',
      tipo: TipoColumnaTabla.FECHA,
    },
  ],
  busqueda: true,
  filtros: [
    {
      nombre: 'Organización',
      slug: 'organizacion',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: [],
      roles: [RolUsuario.ELEVA],
    },
    {
      nombre: 'Punto de Origen',
      slug: 'origen',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: [],
      oculto: true,
    },
    {
      nombre: 'Estado',
      slug: 'estado_real',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: [{ nombre: 'Todos', valor: '' }, ...OPCIONES_ESTADO_REAL_ORDEN],
    },
    {
      nombre: 'Tipo',
      slug: 'tipo',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: [{ nombre: 'Todos', valor: '' }, ...OPCIONES_TIPO_ORDEN],
    },
    {
      nombre: 'Prioridad',
      slug: 'prioridad',
      tipo: TipoCampoFormulario.OPCION_MULTIPLE,
      opciones: [{ nombre: 'Todos', valor: '' }, ...OPCIONES_PRIORIDAD_ORDEN],
    },
    {
      nombre: 'Creación',
      slug: 'fecha_creacion',
      tipo: TipoCampoFormulario.FECHA,
    },
    {
      nombre: 'Preparación',
      slug: 'fecha_preparacion',
      tipo: TipoCampoFormulario.FECHA,
    },
  ],
  botones: [
    {
      nombre: 'Importar',
      slug: 'importar',
      icono: Icono.SUBIR,
      autorizacion: {
        permisos: {
          orden: [Permiso.CREAR_MASIVO],
          cliente: [Permiso.VER_MASIVO],
        },
      },
    },
    {
      nombre: 'Crear',
      slug: 'crear',
      icono: Icono.CREAR,
      autorizacion: { permisos: { orden: [Permiso.CREAR] } },
    },
  ],
  acciones: [
    {
      nombre: 'Ver',
      slug: 'ver',
      icono: Icono.VER,
      autorizacion: { permisos: { orden: [Permiso.VER] } },
    },
    {
      nombre: 'Cancelar',
      slug: 'cancelar',
      icono: Icono.CANCELAR,
      autorizacion: { permisos: { orden: [Permiso.CANCELAR] } },
      ocultar: (fila: FilaTabla) =>
        fila['estado'] === EstadoOrden.RECOGIDA ||
        ESTADOS_ORDEN_ERROR.includes(fila['estado']),
    },
    {
      nombre: 'Generar Etiqueta',
      slug: 'etiqueta',
      icono: Icono.ETIQUETAS,
      autorizacion: {
        permisos: { orden: [Permiso.VER] },
        roles: [RolUsuario.ELEVA, RolUsuario.ORGANIZACION],
      },
      ocultar: (fila: FilaTabla) =>
        !ESTADOS_ORDEN_PREPARADA.includes(fila['estado']),
    },
  ],
};

/* Detalles de la acciones de la tabla de órdenes */
export const DETALLES_ACCIONES_TABLA_ORDENES: Record<
  string,
  {
    componente: any;
    output?: string;
    segmentosUrl: string[];
    width?: number;
  }
> = {
  ver: {
    componente: VerOrdenComponent,
    segmentosUrl: ['ordenes'],
    width: CONFIGURACION_FICHA_VER_ORDEN.maxWidth,
  },
  cancelar: {
    componente: CancelarOrdenComponent,
    segmentosUrl: ['ordenes', 'cancelar'],
    output: 'cancelada',
    width: CONFIGURACION_FICHA_CANCELAR_ORDEN.maxWidth,
  },
};
